var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    attrs: {
      "value": _vm.Liquid.value
    }
  }, [_c('v-container', [_c('top-image', {
    attrs: {
      "tit": _vm.Liquid.text,
      "bgImage": "/images/sub/product/liquid-bg.jpg",
      "image": "/images/sub/product/liquid-img.png"
    }
  }, [_c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v(" We provide Liquid Analyzer System that is designed to provide accurate and reliable measurements of key parameters such as pH, ORP, Conductivity, TOC, Chlorine, Ammonia, and Dissolved oxygen. ")]), _c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v(" Liquid analysis is essential for protecting vital capital assets such as boilers and cooling towers by preventing corrosion, minimizing maintenance, and maximizing uptime. Our system allows you to continuously monitor the chemistry of your process liquid and make adjustments as needed to maintain optimal performance. ")]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" The system is highly customizable and can be tailored to meet the specific needs of your application. It can be used in a wide range of industries such as power generation, water treatment, and chemical processing. ")])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }